/**
 * Admin 레이아웃: 사이드바 토글, 오버레이, ESC, 사용자 드롭다운 외부 클릭.
 * 뷰 인라인 스크립트 제거 후 여기서 처리.
 */
export function initAdminLayoutSidebar(): void {
    const body = document.getElementById("admin-body");
    const sidebar = document.getElementById("admin-sidebar");
    const overlay = document.getElementById("admin-sidebar-overlay");
    const toggleBtns = document.querySelectorAll<HTMLElement>("[data-admin-sidebar-toggle]");

    function closeSidebar(): void {
        if (body) body.classList.remove("admin--sidebar-open");
        toggleBtns.forEach((btn) => {
            btn.setAttribute("aria-expanded", "false");
            btn.setAttribute("aria-label", "메뉴 열기");
        });
        if (overlay) overlay.setAttribute("aria-hidden", "true");
    }

    function openSidebar(): void {
        if (body) body.classList.add("admin--sidebar-open");
        toggleBtns.forEach((btn) => {
            btn.setAttribute("aria-expanded", "true");
            btn.setAttribute("aria-label", "메뉴 닫기");
        });
        if (overlay) overlay.setAttribute("aria-hidden", "false");
    }

    function toggleSidebar(): void {
        if (body?.classList.contains("admin--sidebar-open")) closeSidebar();
        else openSidebar();
    }

    toggleBtns.forEach((btn) => btn.addEventListener("click", toggleSidebar));
    overlay?.addEventListener("click", closeSidebar);
    document.addEventListener("keydown", (e) => {
        if (e.key === "Escape" && body?.classList.contains("admin--sidebar-open")) closeSidebar();
    });
    sidebar?.querySelectorAll("a").forEach((a) => a.addEventListener("click", closeSidebar));

    document.addEventListener("click", (e) => {
        const d = document.querySelector("[data-admin-user-dropdown]");
        if (!d || d.contains(e.target as Node)) return;
        d.removeAttribute("open");
    });
}
